import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaypal, faCcMastercard, faCcVisa, faCcAmex } from '@fortawesome/free-brands-svg-icons';

const paymentData = [
  { iconId: faPaypal },
  { iconId: faCcMastercard },
  { iconId: faCcVisa },
  { iconId: faCcAmex }
];

const PaymentTypes = () => (
  <Fragment>
    <p className="d-none d-lg-block small text-center font-weight-bold mb-0">We accept</p>
    <ul className="Footer-Promoted__Payment">
      {
        paymentData.map((data, index) => (
          <li key={index}>
            <FontAwesomeIcon 
              size="2x"
              color="#ffffff"
              icon={data.iconId} 
            />
          </li>
        ))
      }
    </ul>
  </Fragment>
);

export default PaymentTypes;